import { CommonListData, NavigateRoutes, TransactionModule } from 'common/constants/app.constant';
import { BaseDataModel } from 'common/models/utilitymodels/base.model';
import { HeadersList, ListMetaModel, ListModel } from 'common/models/utilitymodels/list.model';

export class SchemeDetailsModel extends BaseDataModel {
    // Folio_No: string = '';
    // Investor_Name: string = '';
    // PAN: string = '';
    // Investment_Value: string = '';
    // Market_Amount: string = '';
    // Mode_Of_Holding: string = '';
    // Tax_Status: string = '';
}

export class SchemeDetailsListingModel extends ListModel<SchemeDetailsModel> {
    Market_Amount_number: string = '';
}

export class SchemeDetailsMetaModel extends ListMetaModel<HeadersList> {
    transactionModule = TransactionModule;
    constructor() {
        super('Scheme Details', '', true, CommonListData.rowPerPage, NavigateRoutes.investorList);
    }
    prepareHeaderList(): HeadersList[] {
        const headers: HeadersList[] = [];
        const Investor_Name = new HeadersList('Investor Name', 'Investor_Name', true, true, 'text');
        const PAN = new HeadersList('PAN', 'PAN', false, false, 'text');
        const Market_Value = new HeadersList('Market_Amount', 'Market_Value', false, true, 'number', false);
        const Folio_No = new HeadersList('Folio No', 'Folio_No', true, true, 'text');
        const Mode_Of_Holding = new HeadersList('Mode Of Holding', 'Mode_Of_Holding', false, false, 'text');
        const Tax_Status = new HeadersList('Tax Status', 'Tax_Status', false, false, 'text');
        headers.push(Investor_Name);
        headers.push(PAN);
        headers.push(Market_Value);
        headers.push(Folio_No);
        headers.push(Mode_Of_Holding);
        headers.push(Tax_Status);
        return headers;
    }

    initProperties(): any {
        const dataInfo = {
            isEditable: this.isEditable,
            recordPerPage: this.recordPerPage,
            listInfo: this.prepareHeaderList(),
            pointer: undefined,
            isSortOpen: false,
            isFilterOpen: false,
            isFilterOpenInHeader: false,
            page: 'Scheme Details',
            transactionModule: this.transactionModule,
            searchPlaceHolder: 'Search by investor name',
        };
        return dataInfo;
    }
}
